import store from '@/state/store';

export default [
	{
		path: '/volunteer-system',
		name: 'volunteer-system',
		component: () => import('./views/website/index'),
	},
	{
		path: '/volunteer-system/locations',
		name: 'locations',
		props: true,
		component: () => import('./views/website/account-setup/locations'),
	},
	{
		path: '/volunteer-system/create-account-landing',
		name: 'mentor-landing',
		props: true,
		component: () => import('./views/website/account-setup/landing'),
	},
	{
		path: '/volunteer-system/create-account',
		name: 'create-account',
		component: () => import('./views/website/account-setup/create-account'),
	},
	{
		path: '/volunteer-system/contact-info',
		name: 'contact-info',
		component: () => import('./views/website/account-setup/contact-info'),
	},
	{
		path: '/volunteer-system/questions',
		name: 'questions',
		props: true,
		component: () => import('./views/website/account-setup/questions'),
	},
	{
		path: '/volunteer-system/background-check',
		name: 'background-check',
		props: true,
		component: () => import('./views/website/account-setup/background-check'),
	},
	{
		path: '/volunteer-system/faith',
		name: 'faith',
		props: true,
		component: () => import('./views/website/account-setup/faith'),
	},
	{
		path: '/volunteer-system/references',
		name: 'references',
		props: true,
		component: () => import('./views/website/account-setup/references'),
	},
	{
		path: '/volunteer-system/employment',
		name: 'employment',
		props: true,
		component: () => import('./views/website/account-setup/employment'),
	},
	{
		path: '/volunteer-system/additional-details',
		name: 'additional-details',
		props: true,
		component: () => import('./views/website/account-setup/additional-details'),
	},
	{
		path: '/volunteer-system/become-mentor/background-check',
		name: 'mentor-background-check',
		props: true,
		component: () => import('./views/website/become-mentor/background-check'),
	},
	{
		path: '/volunteer-system/become-mentor/references',
		name: 'mentor-references',
		props: true,
		component: () => import('./views/website/become-mentor/references'),
	},
	{
		path: '/volunteer-system/become-mentor/review-application',
		name: 'mentor-review-application',
		props: true,
		component: () => import('./views/website/become-mentor/review-application'),
	},
	{
		path: '/volunteer-system/become-mentor/thankyou',
		name: 'mentor-thankyou',
		props: true,
		component: () => import('./views/website/become-mentor/thankyou'),
	},
	{
		path: '/volunteer-system/sing-in',
		name: 'sign-in',
		props: true,
		component: () => import('./views/website/account-setup/sign-in'),
	},
	{
		path: '/volunteer-system/review-application',
		name: 'review-application',
		component: () => import('./views/website/account-setup/review-application'),
	},
	{
		path: '/volunteer-system/landing',
		name: 'volunteer-landing',
		props: true,
		component: () => import('./views/website/account-setup/volunteer-landing'),
	},
	{
		path: '/volunteer-system/opportunities',
		name: 'opportunities',
		props: true,
		component: () => import('./views/website/account-setup/opportunities'),
	},
	{
		path: '/volunteer-system/review-application',
		name: 'volunteer-review-application',
		props: true,
		component: () => import('./views/website/account-setup/review-volunteer-application'),
	},
	{
		path: '/volunteer-system/thankyou',
		name: 'thankyou',
		props: true,
		component: () => import('./views/website/account-setup/thankyou'),
	},
	{
		path: '/volunteer-system/ch-reference-thankyou',
		name: 'ch_reference_thankyou',
		props: true,
		component: () => import('./views/website/account-setup/ch-reference-thankyou'),
	},
	{
		path: '/volunteer-system/profile',
		name: 'profile',
		props: true,
		component: () => import('./views/website/account-setup/profile'),
	},
	{
		path: '/volunteer-system/profile/update',
		name: 'profile-update',
		props: true,
		component: () => import('./views/website/account-setup/profile-update'),
	},
	{
		path: '/volunteer-system/available_roles',
		name: 'available_roles',
		props: true,
		component: () => import('./views/website/account-setup/volunteerAvailableRoles'),
	},
	{
		path: '/volunteer-system/mentor-hours',
		name: 'mentor-hours',
		props: true,
		component: () => import('./views/website/account-setup/mentorHours'),
	},
	{
		path: '/volunteer-system/volunteer-roles',
		name: 'volunteer-roles',
		props: true,
		component: () => import('./views/website/account-setup/volunteerRoles'),
	},

	{
		path: '/volunteer-system/contact-us',
		name: 'contact',
		props: true,
		component: () => import('./views/website/account-setup/contact'),
	},
	{
		path: '/',
		name: 'dashboard',
		meta: { authRequired: true },
		props: true,
		component: () => import('./views/dashboard'),
	},
	{
		path: '/user-tasks',
		name: 'user-tasks',
		meta: { authRequired: true },
		props: true,
		component: () => import('./views/user-tasks'),
	},
	{
		path: '/registration-progress',
		name: 'registration-progress',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/registration-progress'),
	},
	{
		path: '/registration-progress-incomplete',
		name: 'registration-progress-incomplete',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/registration-progress-incomplete'),
	},
	{
		path: '/registration-progress/user/:id',
		name: 'user-profile',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/user-profile/profile'),
	},
	{
		path: '/profile/:id',
		name: 'my-profile',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/profile'),
	},
	{
		path: '/resources',
		name: 'resources',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/resources'),
	},
	{
		path: '/search',
		name: 'search',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/search'),
	},
	{
		path: '/dashboard-locations',
		name: 'dashboard-locations',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/locations'),
	},
	{
		path: '/buildings',
		name: 'buildings',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/buildings'),
	},
	{
		path: '/users',
		name: 'users',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/users'),
	},
	{
		path: '/departments',
		name: 'departments',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/departments'),
	},
	{
		path: '/roles',
		name: 'roles',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/roles'),
	},
	{
		path: '/categories',
		name: 'categories',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/categories'),
	},
	{
		path: '/reports',
		name: 'reports',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/reports'),
	},
	{
		path: '/report/:slug',
		name: 'report',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/allReports'),
	},
	{
		path: '/approvals',
		name: 'approvals',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/approvals/listing'),
	},
	{
		path: '/approvals/mytasks',
		name: 'mytasks',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/approvals/mytasks'),
	},
	{
		path: '/site-settings',
		name: 'settings',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/site-settings/settings'),
	},
	{
		path: '/email-templates',
		name: 'Email Templates',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/site-settings/EmailTemplates'),
	},
	{
		path: '/approval-settings',
		name: 'Approval Settings',
		meta: {
			authRequired: true,
		},
		component: () => import('./views/site-settings/ApprovalSettings'),
	},
	{
		path: '/approvals/user/:id/:user_id',
		name: 'approvals-user-profile',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/approvals/application'),
	},
	{
		path: '/email/reademail/:id',
		name: 'Read Email',
		meta: { authRequired: true },
		props: true,
		component: () => import('./views/email/reademail'),
	},
	{
		path: '/sentmail',
		name: 'sentmail',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/email/sentmail'),
	},
	{
		path: '/scheduling',
		name: 'scheduling',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/schedules'),
	},
	{
		path: '/scheduling-calendar/:location_id/:role_id',
		name: 'schedulingCalendar',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/scheduleCalendar'),
	},
	{
		path: '/scheduling-calendar-filter',
		name: 'schedulingCalendarFilter',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/scheduleCalendarFilter'),
	},

	{
		path: '/assignment-approver',
		name: 'assignment-approver',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/assignment-approver'),
	},
	{
		path: '/volunteer-system/reference',
		name: 'reference',
		props: true,
		component: () => import('./views/website/account-setup/reference'),
	},
	{
		path: '/volunteer-system/login',
		name: 'login',
		component: () => import('./views/website/account-setup/login'),
		meta: {
			beforeResolve(routeTo, routeFrom, next) {
				// If the user is already logged in
				if (store.getters['authfack/loggedIn']) {
					// Redirect to the home page instead
					next({ name: 'volunteer-system' });
				} else {
					// Continue to the login page
					next();
				}
			},
		},
	},
	{
		path: '/login',
		name: 'admin-login',
		component: () => import('./views/login'),
		meta: {
			beforeResolve(routeTo, routeFrom, next) {
				// If the user is already logged in
				if (store.getters['authfack/loggedIn']) {
					// Redirect to the home page instead
					next({ name: 'dashboard' });
				} else {
					// Continue to the login page
					next();
				}
			},
		},
	},
	{
		path: '/register',
		name: 'Register',
		component: () => import('./views/account/register'),
		meta: {
			beforeResolve(routeTo, routeFrom, next) {
				// If the user is already logged in
				if (store.getters['authfack/loggedIn']) {
					// Redirect to the home page instead
					next({ name: 'default' });
				} else {
					// Continue to the login page
					next();
				}
			},
		},
	},
	{
		path: '/forgot-password',
		name: 'Forgot password',
		component: () => import('./views/account/forgot-password'),
		meta: {
			beforeResolve(routeTo, routeFrom, next) {
				// If the user is already logged in
				if (store.getters['auth/loggedIn']) {
					// Redirect to the home page instead
					next({ name: 'default' });
				} else {
					// Continue to the login page
					next();
				}
			},
		},
	},
	{
		path: '/reset-password',
		name: 'Reset password',
		props: true,
		component: () => import('./views/account/reset-password'),
		meta: {
			beforeResolve(routeTo, routeFrom, next) {
				// If the user is already logged in
				if (store.getters['auth/loggedIn']) {
					// Redirect to the home page instead
					next({ name: 'default' });
				} else {
					// Continue to the login page
					next();
				}
			},
		},
	},

	{
		path: '/logout',
		name: 'logout',
		meta: {
			authRequired: true,
			beforeResolve(routeTo, routeFrom, next) {
				// if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
				//   store.dispatch('auth/logOut')
				// } else {
				//   store.dispatch('authfack/logout')
				// }
				const authRequiredOnPreviousRoute = routeFrom.matched.some((route) => route.push('/login'));
				// Navigate back to previous page, or home as a fallback
				next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom });
			},
		},
	},
	{
		path: '/404',
		name: '404',
		component: require('./views/utility/404').default,
	},
	// Redirect any unmatched routes to the 404 page. This may
	// require some server configuration to work in production:
	// https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
	{
		path: '*',
		redirect: '404',
	},
	{
		path: '/editor-test',
		name: 'editor-test',
		meta: {
			authRequired: true,
		},
		props: true,
		component: () => import('./views/editor-test'),
	},
];
